import { render, staticRenderFns } from "./knowledgePointsCard.vue?vue&type=template&id=09adba40&scoped=true&"
import script from "./knowledgePointsCard.vue?vue&type=script&lang=js&"
export * from "./knowledgePointsCard.vue?vue&type=script&lang=js&"
import style0 from "./knowledgePointsCard.vue?vue&type=style&index=0&id=09adba40&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09adba40",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBtn,VCard,VIcon})
